import React from "react";
import { Card, Form, Row, Col, Button } from "react-bootstrap";

const VideoSection = ({ data, onUpdate }) => {
  const MAX_VIDEOS = 5;

  // Initialize videoUrls if it doesn't exist or convert old videoUrl to array
  const videoUrls = React.useMemo(() => {
    if (data.videoUrls && Array.isArray(data.videoUrls)) {
      return data.videoUrls;
    }
    // Handle legacy data with single videoUrl
    if (data.videoUrl) {
      return [data.videoUrl];
    }
    return [""];
  }, [data.videoUrls, data.videoUrl]);

  const handleVisibilityChange = (e) => {
    onUpdate({ ...data, isVisible: e.target.checked, videoUrls });
  };

  const handleVideoUrlChange = (index, value) => {
    const newVideoUrls = [...videoUrls];
    newVideoUrls[index] = value;
    onUpdate({ ...data, videoUrls: newVideoUrls });
  };

  const addVideoUrl = () => {
    if (videoUrls.length < MAX_VIDEOS) {
      onUpdate({ ...data, videoUrls: [...videoUrls, ""] });
    }
  };

  const removeVideoUrl = (index) => {
    const newVideoUrls = videoUrls.filter((_, i) => i !== index);
    onUpdate({ ...data, videoUrls: newVideoUrls.length > 0 ? newVideoUrls : [""] });
  };

  return (
    <Card className="mb-4">
      <Card.Header className="d-flex justify-content-between align-items-center">
        <h5 className="mb-0">Video Section</h5>
        <Form.Check
          type="switch"
          id="video-section-visibility"
          label="Visible"
          checked={data.isVisible}
          onChange={handleVisibilityChange}
        />
      </Card.Header>
      <Card.Body>
        <Form.Group className="mb-3">
          <Form.Label>Video URLs (Max 5)</Form.Label>
          {videoUrls.map((url, index) => (
            <div key={index} className="mb-2">
              <div className="d-flex gap-2">
                <div className="flex-grow-1">
                  <Form.Control
                    type="url"
                    value={url}
                    onChange={(e) => handleVideoUrlChange(index, e.target.value)}
                    placeholder={index === 0 ? "Enter main video URL (YouTube, Vimeo, etc.)" : "Enter video URL"}
                  />
                  {index === 0 && (
                    <Form.Text className="text-muted">
                      Main video - will be displayed prominently
                    </Form.Text>
                  )}
                </div>
                {videoUrls.length > 1 && (
                  <Button
                    variant="outline-danger"
                    size="sm"
                    onClick={() => removeVideoUrl(index)}
                  >
                    ×
                  </Button>
                )}
              </div>
            </div>
          ))}
          {videoUrls.length < MAX_VIDEOS && (
            <Button
              variant="outline-primary"
              size="sm"
              onClick={addVideoUrl}
              className="mt-2"
            >
              + Add Video URL ({videoUrls.length}/{MAX_VIDEOS})
            </Button>
          )}
        </Form.Group>
      </Card.Body>
    </Card>
  );
};

export default VideoSection;
